import { Component, ViewChild, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { Company } from '../company/company.model';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { CompanyService } from './company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'company-edit',
  templateUrl: './company-edit.component.html',
  styleUrls: ['./company-edit.component.css']
})

export class CompanyEditComponent implements OnInit, OnDestroy {
  @ViewChild('editForm', { static: false }) editForm: NgForm;
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;

  private company = new Company();
  private isNew: boolean = true;
  private modal: any;
  private isUploaded: boolean = false;
  private dispUploadErr: any;
  private subs = new SubSink();

  @Output()
  private saved: EventEmitter<Company> = new EventEmitter<Company>();

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService, private companyEditService: CompanyService) { }

  ngOnInit() {
    this.modal = $('#companyForm');
    this.dispUploadErr = $('#uploadErr');
  }

  public show(company: Company, isNew: boolean) {
    this.editForm.reset();
    this.company = company;
    this.isNew = isNew;

    if (this.company.image) {
      this.isUploaded = true;
    }

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  private upload(event: any) {
    let that = this;
    const target: DataTransfer = <DataTransfer>(event.target);
    const reader = new FileReader();

    let file = target.files[0];

    if (file) {
      let fileType = /image.*/;

      if (file.type.match(fileType)) {
        reader.onload = function (e: any) {
          that.company.image = reader.result.toString();
          that.isUploaded = true;

          if (that.dispUploadErr.children().length > 0)
            that.dispUploadErr.empty();
        }

        reader.readAsDataURL(file);
      } else {
        if (this.isUploaded)
          this.isUploaded = false;

        this.dispUploadErr.html('<div class="alert-info w-100 text-center">File is not a valid image</div>');
      }
    }
  }

  private insert() {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Create company', 'error');
      } else {
        this.subs.sink = this.repository.post<Company>('api/Company/Create', this.company, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Create company', 'error');
          } else {
            Toast.Show('Company successfully created.', 'Create company', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private update() {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Update company', 'error');
      } else {
        this.subs.sink = this.repository.put<Company>('api/Company/Edit', this.company, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Update company', 'error');
          } else {
            Toast.Show('Company updated successfully.', 'Update company', 'success');
            this.changeCompany(resp.data);
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private changeCompany(company: Company) {
    this.companyEditService.changeCompany(company);
  }

  private save() {
    if (this.editForm.valid) {

      if (this.isNew)
        this.insert();
      else
        this.update();

    } else {
      Object.keys(this.editForm.controls)
        .forEach(fieldName => {
          this.editForm.controls[fieldName].markAsDirty();
        });
      $('#code').focus();
    }
  }

  private onSaveCompleted(data: Company) {
    this.close();
    this.saved.emit(data);
  }

  private close() {
    this.modal.modal('hide');
    this.company = new Company();
    this.isUploaded = false;
  }

  private reset() {
    this.isUploaded = false;
    this.dispUploadErr.empty();
    this.company.image = null;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
